export default "__VITE_ASSET__Bg$rvsLb__"